import React from "react";
import { COLORS, FONTS } from "@/constants/theme";

/**
 * Wordmark de ALTAMA CONSULTING con isotipo basado en la marca "A + punto".
 *
 * @param {{
 *   size?: "md" | "lg",
 *   textColor?: string,
 *   subColor?: string
 * }} props
 * @returns {JSX.Element}
 */
const BrandLogo = ({
  size = "md",
  textColor = COLORS.textPrimary,
  subColor = COLORS.textSecondary,
}) => {
  const isLarge = size === "lg";

  return (
    <span className="inline-flex items-center gap-3 leading-none">
      <span
        aria-hidden="true"
        style={{
          width: isLarge ? "48px" : "44px",
          height: isLarge ? "48px" : "44px",
          borderRadius: "12px",
          background: "linear-gradient(145deg, #04103a 0%, #07245b 100%)",
          border: "1px solid rgba(10, 74, 228, 0.72)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#f4f7ff",
          flexShrink: 0,
          position: "relative",
        }}
      >
        <span
          style={{
            fontFamily: FONTS.heading,
            fontWeight: 800,
            fontSize: isLarge ? "2.05rem" : "1.86rem",
            lineHeight: 1,
            transform: "translateY(-1px)",
          }}
        >
          A
        </span>
        <span
          style={{
            position: "absolute",
            right: isLarge ? "4px" : "3px",
            bottom: isLarge ? "5px" : "4px",
            width: isLarge ? "8px" : "7px",
            height: isLarge ? "8px" : "7px",
            borderRadius: "50%",
            backgroundColor: "#0f63ff",
          }}
        />
      </span>

      <span className="flex flex-col">
        <span
          style={{
            color: textColor,
            fontFamily: FONTS.heading,
            fontWeight: 700,
            fontSize: isLarge ? "1.19rem" : "1.08rem",
            letterSpacing: "0.055em",
            textTransform: "uppercase",
            lineHeight: 1,
          }}
        >
          ALTAMA
        </span>
        <span
          style={{
            marginTop: "0.18rem",
            color: subColor,
            fontFamily: FONTS.body,
            fontWeight: 600,
            fontSize: isLarge ? "0.66rem" : "0.62rem",
            letterSpacing: "0.19em",
            textTransform: "uppercase",
            lineHeight: 1,
          }}
        >
          CONSULTING
        </span>
      </span>
    </span>
  );
};

export default BrandLogo;
